import { c as _c } from "react/compiler-runtime";
import { Shimmer } from '@onefootprint/ui';
import QRCode from 'react-qr-code';
const QR_CODE_SIZE = 168;
type QrCodeDisplayProps = {
  isLoading?: boolean;
  text?: string;
  qrValue?: string;
};
const QrCodeDisplay = t0 => {
  const $ = _c(8);
  const {
    qrValue,
    isLoading,
    text
  } = t0;
  let t1;
  if ($[0] !== text) {
    t1 = text && <p className="text-body-2 text-secondary text-center">{text}</p>;
    $[0] = text;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== isLoading || $[3] !== qrValue) {
    t2 = isLoading || !qrValue ? <Shimmer height={`${QR_CODE_SIZE}px`} width={`${QR_CODE_SIZE}px`} /> : <div className="bg-secondary rounded items-center justify-center flex p-2 border border-tertiary" data-dd-privacy="mask"><QRCode size={QR_CODE_SIZE} value={qrValue} /></div>;
    $[2] = isLoading;
    $[3] = qrValue;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <div className="py-6 flex flex-col items-center gap-4">{t1}{t2}</div>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default QrCodeDisplay;